import { useState } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import Icon from '../icon'
import Typography from '../typography'
import { useBreakpoint } from '../../../hooks/breakpoint'

import ChevronUp from '../icon/chevron-up.svg'
import ChevronDown from '../icon/chevron-down.svg'

const FAQ = ({ question, answer, ...attrs }) => {
  const breakpoint = useBreakpoint()
  const [isActive, setIsActive] = useState(false)

  attrs.className = classNames(
    attrs.className,
    [
      'border',
      'border-gray-300'
    ]
  )

  attrs.style = {
    ...(attrs.style || {}),
    borderRadius: breakpoint.mdAndUp ? '0 0.75rem 0.75rem 0.75rem' : '0 1.5rem 1.5rem 1.5rem'
  }

  return <div
    {...attrs}>
    <div
      className={
        classNames([
          breakpoint.mdAndUp ? 'p-8' : 'p-4',
          'flex',
          'flex-row',
          'items-start',
          'cursor-pointer'
        ])
      }
      onClick={() => setIsActive(!isActive)}>
      <Icon
        svg={isActive ? ChevronUp : ChevronDown}
        width={24}
        height={24}
        className={'flex-none mr-2 text-green-600'} />
      <Typography
        tag={'div'}
        size={'three'}
        weight={'bold'}
        className={'text-gray-500'}>
        {question}
      </Typography>
    </div>
    {
      isActive
        ? <div
          className={
            classNames([
              breakpoint.mdAndUp ? 'pt-0' : 'pt-0',
              breakpoint.mdAndUp ? 'pb-8' : 'pb-4',
              breakpoint.mdAndUp ? 'pr-8' : 'pr-4',
              breakpoint.mdAndUp ? 'pl-16' : 'pl-4',
              'flex',
              'flex-row',
              'items-start'
            ])
          }>
          <Typography
            tag={'div'}
            size={'three'}
            weight={'regular'}
            className={'text-gray-500'}>
            {answer}
          </Typography>
        </div>
        : null
    }
  </div>
}

FAQ.propTypes = {
  question: PropTypes.string,
  answer: PropTypes.string
}

const FAQs = ({ title, items = [], titleAttrs = {}, ...attrs }) => {
  const hasFAQs = items.length > 0

  titleAttrs.size = titleAttrs.size || 'four'
  titleAttrs.weight = titleAttrs.weight || 'black'

  return hasFAQs
    ? <div
      {...attrs}>
      <Typography
        {...titleAttrs}>
        {title || 'Preguntas frecuentes'}
      </Typography>
      {
        items.map(
          (item, index) => {
            const { question, answer } = item.value
            const lastItem = (index === items.length - 1)
            return <FAQ
              key={item.id}
              answer={answer}
              question={question}
              className={
                classNames([
                  !lastItem && 'mb-4'
                ])
              } />
          }
        )
      }
    </div>
    : null
}

FAQs.propTypes = {
  title: PropTypes.string,
  items: PropTypes.array,
  titleAttrs: PropTypes.object
}

export default FAQs
